import React, { useState } from "react";
import { Link } from "react-router-dom";
import { track } from "@vercel/analytics";
import { useAuth } from "../../context/AuthContext";
import AuthModal from "../AuthModal/AuthModal";
import { PRODUCT_SCREENSHOTS } from "../ProductPages/productScreenshots";

const HomeRunCta = () => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleRunTournament = (e) => {
    track("create_tournament_click", { location: "home_overview_cta" });
    if (!user) {
      e.preventDefault();
      setShowAuthModal(true);
    }
  };

  return (
    <>
      <section className="bg-brand-cream pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="border-t border-brand-charcoal/10 pt-16 md:pt-20">
          <h2 className="heading-display text-3xl md:text-4xl">
            Run your next tournament
          </h2>
          <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
          <p className="mt-4 text-brand-muted max-w-2xl">
            Create the tournament, build your squads, and open signups so
            bowlers can pick a squad themselves.
          </p>
          <div className="mt-8">
            <Link
              to="/create-tournament"
              onClick={handleRunTournament}
              className="btn-brand md:px-8 md:py-3"
            >
              Run a tournament
            </Link>
          </div>
          <figure className="mt-10 max-w-4xl">
            <div className="card-board overflow-hidden">
              <img
                src={PRODUCT_SCREENSHOTS.overview.src}
                alt={PRODUCT_SCREENSHOTS.overview.alt}
                className="w-full"
                width={1600}
                height={1000}
              />
            </div>
          </figure>
          </div>
        </div>
      </section>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </>
  );
};

export default HomeRunCta;
